import React from "react";
import { HubFilterMenu } from "../../components";

const types = [
  {
    id: "A",
    label: "Active",
  },
  {
    id: "T",
    label: "Terminated",
  },
  {
    id: "O",
    label: "Other",
  },
  {
    id: "L",
    label: "Leave of Absence",
  },
];

const OrganizationUserstatusFilter = ({ ...rest }) => {
  return (
    <HubFilterMenu
      id="status"
      options={types}
      menuLabel="Filter Users by Status"
      label="User Status"
      useDefault={false}
      {...rest}
    />
  );
};

export default OrganizationUserstatusFilter;
